import axios from "../../axiosConfig";
import { call, put } from "redux-saga/effects";
import {
  GLU_CREATE_CAMPAIGN_FAILURE,
  GLU_CREATE_CAMPAIGN_SUCCESS,
  GLU_GET_CAMPAIGNS_LIST_FAILURE,
  GLU_GET_CAMPAIGNS_LIST_SUCCESS,
  GLU_GET_CAMPAIGN_STATUS_FAILURE,
  GLU_GET_CAMPAIGN_STATUS_SUCCESS,
  GLU_GET_CAMPAIGN_SUCCESS,
  GLU_GET_CAMPAIGN_FAILURE
} from "../Actions/GLUActions";

export function* getCampaignsListSaga(): unknown {
  try {
    const response = yield call(axios.get, "gluCampaigns");

    const { data, status } = response;

    if (status === 200) {
      const campaignsListArray = data.creatives;
      yield put({
        type: GLU_GET_CAMPAIGNS_LIST_SUCCESS,
        payload: campaignsListArray,
      });
    } else {
      yield put({
        type: GLU_GET_CAMPAIGNS_LIST_FAILURE,
        payload: {
          message: "Something went wrong..",
        },
      });
    }
  } catch (e) {
    yield put({
      type: GLU_GET_CAMPAIGNS_LIST_FAILURE,
      payload: {
        message: e,
      },
    });
  }
}

export function* getCampaignData(action:any):unknown{
  try {
    const response = yield call(axios.get, `gluCampaign?id=${action.payload}`);

    const { data, status } = response;
    if (status === 200) {
      yield put({
        type: GLU_GET_CAMPAIGN_SUCCESS,
        payload: data,
      });
    } else {
      yield put({
        type: GLU_GET_CAMPAIGN_FAILURE,
        payload: {
          message: "Something went wrong..",
        },
      });
    }
  } catch (e) {
    yield put({
      type: GLU_GET_CAMPAIGN_FAILURE,
      payload: {
        message: "Something went wrong..",
      },
    });
  }

}

export function* getCampaignStatusSaga(action: any): unknown {
  try {
    const response = yield call(axios.get, `gluCampaignStatus?id=${action.payload}`);

    const { data, status } = response;
    if (status === 200) {
      yield put({
        type: GLU_GET_CAMPAIGN_STATUS_SUCCESS,
        payload: data,
      });
    } else {
      yield put({
        type: GLU_GET_CAMPAIGN_STATUS_FAILURE,
        payload: {
          message: "Something went wrong..",
        },
      });
    }
  } catch (e) {
    yield put({
      type: GLU_GET_CAMPAIGN_STATUS_FAILURE,
      payload: {
        message: "Something went wrong..",
      },
    });
  }
}

export function* createCampaignSaga(action: any): unknown {
  try {
    const response = yield call(axios.post, "createGluCampaign", action.payload);
    const { status } = response;

    if (status === 200) {
      yield put({
        type: GLU_CREATE_CAMPAIGN_SUCCESS,
        payload: true,
      });
    } else {
      yield put({
        type: GLU_CREATE_CAMPAIGN_FAILURE,
        payload: {
          message: "Something went wrong..",
        },
      });
    }
  } catch (e) {
    yield put({
      type: GLU_CREATE_CAMPAIGN_FAILURE,
      payload: {
        message: e,
      },
    });
  }
}
